import { AccountsAPI } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";

const LEDGER_CARD_SETTINGS_BASE = "/AccountSettings/LedgerSettings";

const getLedgerCardSettingsAPI = async () => {
  const result = await AccountsAPI.get(LEDGER_CARD_SETTINGS_BASE);
  const postingStyles = result.data?.data?.postingStyles ?? [];
  return { data: { data: postingStyles } };
};

const updateLedgerCardSettingAPI = (id, data) =>
  AccountsAPI.put(
    `${LEDGER_CARD_SETTINGS_BASE}`,
    JSON.stringify({
      data: {
        postingStyles: [{ ...data }],
      },
    }),
    { headers: { "Content-Type": "application/json" } }
  );

const baseService = createApplicationService({
  name: "ledgerCardSettings",
  apiFetchFn: getLedgerCardSettingsAPI,
  apiUpdateFn: updateLedgerCardSettingAPI,
});

const ledgerCardSettingsReducer = baseService.reducer;
const getLedgerCardSettings = baseService.getData;
const updateLedgerCardSetting = baseService.updateData;
const useLedgerCardSettings = baseService.useData;

export {
  ledgerCardSettingsReducer,
  getLedgerCardSettings,
  updateLedgerCardSetting,
  useLedgerCardSettings,
};
